import { useQuery } from '@tanstack/react-query';
import { TwilioMessage } from '@twilio/conversations';
import queryClient from 'app/services/queryClient';

const connectionMessageQueryKey = ['connectionMessage'];

export default function useConnectingMessage() {
  const { data } = useQuery<TwilioMessage | null>({
    queryKey: connectionMessageQueryKey,
    queryFn: async () => null,
  });

  return data;
}

export function setConnectingMessage(message: TwilioMessage) {
  if (message) {
    queryClient.setQueryData(connectionMessageQueryKey, message);
  }
}

export function clearConnectingMessage() {
  queryClient.invalidateQueries({ queryKey: connectionMessageQueryKey });
}
